import { render, staticRenderFns } from "./Contactpersons.vue?vue&type=template&id=76d7ccbb&scoped=true&"
import script from "./Contactpersons.vue?vue&type=script&lang=js&"
export * from "./Contactpersons.vue?vue&type=script&lang=js&"
import style0 from "./Contactpersons.vue?vue&type=style&index=0&id=76d7ccbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d7ccbb",
  null
  
)

export default component.exports